(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2181],{

/***/ 57401:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/case-study",
      function () {
        return __webpack_require__(58971);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 58971:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ case_study; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/views/WhoWeAre/components/GetInTouchWhite.tsx/GetInTouchWhite.tsx + 2 modules
var GetInTouchWhite = __webpack_require__(87932);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
;// CONCATENATED MODULE: ./src/views/CaseStudy/CaseStudy.tsx



var ImgFifthSection = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 7627).then(__webpack_require__.bind(__webpack_require__, 67627));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(67627)
            ];
        }
    }
});
var ImgFirstSection = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 2778).then(__webpack_require__.bind(__webpack_require__, 82778));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(82778)
            ];
        }
    }
});
var ImgFourthSection = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 1248).then(__webpack_require__.bind(__webpack_require__, 71248));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(71248)
            ];
        }
    }
});
var ImgSecondSection = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 9841).then(__webpack_require__.bind(__webpack_require__, 19841));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(19841)
            ];
        }
    }
});
var ImgSixthSection = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 3498).then(__webpack_require__.bind(__webpack_require__, 53498));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(53498)
            ];
        }
    }
});
var ImgThirdSection = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 571).then(__webpack_require__.bind(__webpack_require__, 90571));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(90571)
            ];
        }
    }
});
var CaseStudy = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "pt-[100px] lg:p-[70px]",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("h1", {
                        className: "text-center text-[2.57143rem] mb-20 py-8",
                        children: [
                            "Case ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                children: "studies"
                            }),
                            "."
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "2xl:mx-[22px] mx-[0.7%]",
                        children: [
                            " ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ImgFirstSection, {}),
                            " "
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "lg:block hidden",
                        children: [
                            " ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ImgSecondSection, {}),
                            " "
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "lg:block hidden",
                        children: [
                            " ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ImgThirdSection, {}),
                            " "
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "my-[150px]"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "",
                        children: [
                            " ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ImgFourthSection, {}),
                            " "
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "",
                        children: [
                            " ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ImgFifthSection, {}),
                            " "
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "lg:mt-[150px] 3xl:my-0"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "",
                        children: [
                            " ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ImgSixthSection, {}),
                            " "
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "w-full",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(GetInTouchWhite["default"], {})
            })
        ]
    });
};
/* harmony default export */ var CaseStudy_CaseStudy = (CaseStudy);

;// CONCATENATED MODULE: ./src/views/CaseStudyMobile/CaseStudyMobile.tsx



var FifthSection = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 5704).then(__webpack_require__.bind(__webpack_require__, 85704));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(85704)
            ];
        }
    }
});
var FirstSection = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 1844).then(__webpack_require__.bind(__webpack_require__, 61844));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(61844)
            ];
        }
    }
});
var FourthSection = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 4618).then(__webpack_require__.bind(__webpack_require__, 4618));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(4618)
            ];
        }
    }
});
var SecondSection = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 3373).then(__webpack_require__.bind(__webpack_require__, 63373));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(63373)
            ];
        }
    }
});
var SixthSection = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 5629).then(__webpack_require__.bind(__webpack_require__, 35629));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(35629)
            ];
        }
    }
});
var ThirdSection = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 785).then(__webpack_require__.bind(__webpack_require__, 785));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(785)
            ];
        }
    }
});
var CaseStudyMobile = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "pt-[6.8rem] lg:p-[70px]",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("h1", {
                        className: "text-center text-[2.57143rem] leading-[1.22222em] pt-8 md:pb-12 pb-10",
                        children: [
                            "Case ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                children: "studies."
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "mb-[120px] md:mb-[200px]",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(FirstSection, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(SecondSection, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ThirdSection, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(FourthSection, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(FifthSection, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(SixthSection, {})
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "w-full",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(GetInTouchWhite["default"], {})
            })
        ]
    });
};
/* harmony default export */ var CaseStudyMobile_CaseStudyMobile = (CaseStudyMobile);

;// CONCATENATED MODULE: ./src/pages/case-study/index.tsx



var CaseStudyPage = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "lg:block hidden",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CaseStudy_CaseStudy, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "lg:hidden block",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CaseStudyMobile_CaseStudyMobile, {})
            })
        ]
    });
};
/* harmony default export */ var case_study = (CaseStudyPage);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [7932,9774,2888,179], function() { return __webpack_exec__(57401); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);